import { render, staticRenderFns } from "./ProductShortDetails.vue?vue&type=template&id=0f9d3690&scoped=true"
import script from "./ProductShortDetails.vue?vue&type=script&lang=js"
export * from "./ProductShortDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductShortDetails.vue?vue&type=style&index=0&id=0f9d3690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d3690",
  null
  
)

export default component.exports